export const url = (imageData) => {
    const output = new URL(imageData?.src ?? imageData?.url ?? imageData, `https://${window.Shopify.cdnHost}`)

    output.searchParams.append('width', '{width}')
    output.searchParams.append('height', '{height}')
    output.searchParams.append('crop', 'center')

    return decodeURI(output.toString())
}

export function image(imageData, className = '', alt) {
    return `
    <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(imageData)}"
    data-sizes="auto"
    alt="${alt ?? ''}"
    class="lazyload ${className}"
    decoding="async"
  >`
}

export const source = (imageData, media, aspect = imageData.width / imageData.height) => `
  <source
    data-src="${url(imageData)}"
    data-aspectratio="${aspect}"
    media="(min-width: ${media})"
  >
`

export default {
    image,
    source,
    url,
}
